import { render, staticRenderFns } from "./DateTimeType.vue?vue&type=template&id=77a216ea&"
import script from "./DateTimeType.vue?vue&type=script&lang=js&"
export * from "./DateTimeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a216ea')) {
      api.createRecord('77a216ea', component.options)
    } else {
      api.reload('77a216ea', component.options)
    }
    module.hot.accept("./DateTimeType.vue?vue&type=template&id=77a216ea&", function () {
      api.rerender('77a216ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/DateTimeType.vue"
export default component.exports